import {useDebugValue, useEffect} from 'react';

import {getObjectValues} from '../../../utils';

function useSubmitActions(data) {
    const {
        events: {
            onSettingsChange
        },
        initialSettings,
        changeSettings
    } = data;

    function setSettings(nextSettings) {
        changeSettings(nextSettings);

        onSettingsChange(nextSettings);
    }

    function setSettingsInitial() {
        setSettings(initialSettings);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(setSettingsInitial, [...getObjectValues(initialSettings)]);

    const result = {
        setSettings
    };

    useDebugValue(result);

    return result;
}

export {useSubmitActions};
